module.exports = __webpack_public_path__ + "img/system41-details.eea61e4f.png";